import axios from "axios";
import { InvalidGraphqlRequest } from "./graphqlTypes";
import checkQueryReqParams from "./request";
const fetchQuery = async ({
  queryKey,
  signal
}) => {
  const [{ params }, variables, { endpoint, method, headers }] = queryKey;
  checkQueryReqParams(params);
  const { id: doc_id, text: query, name: operationName } = params;
  const res = await axios({
    url: endpoint,
    method,
    signal,
    headers: headers && Object.keys(headers).reduce((acc, key) => ({
      ...headers[key] && { [key]: headers[key] },
      ...acc
    }), {}),
    data: {
      ...doc_id ? { doc_id } : { query },
      variables,
      operationName
    },
    validateStatus: () => true
  }).catch((err) => Promise.reject(new InvalidGraphqlRequest(err.message)));
  const body = await res.data;
  if (!body) {
    return Promise.reject(new Error(`GraphQL: Empty Response Body, Endpoint: ${endpoint} Query: ${doc_id || query || "MISSING"} OperationName: ${operationName} Variables: ${JSON.stringify(variables)}`));
  }
  if (body.errors) {
    return Promise.reject(body.errors);
  }
  return body.data;
};
var fetch_default = fetchQuery;
export {
  fetch_default as default
};
